<template>
  <div v-if="operation.documents && operation.documents.length > 0" class="col-12 col-lg-6 d-flex flex-column p-3">
    <OperationsTitle name="Documents" />
    <DownloadableFileList :documents="operation.documents" :is-downloadable="true" />
  </div>
</template>

<script>
import OperationsTitle from "../common/OperationsTitle.vue";
import DownloadableFileList from "@/components/documents/DownloadableFileList.vue";

export default {
  name: "OperationsDocuments",
  components: {
    OperationsTitle,
    DownloadableFileList,
  },
  props: {
    operation: { type: Object, required: true },
  },
};
</script>

<style scoped></style>
